import React, { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import ItemContainer from "../../modules/order/containers/Item";
import withPage from "./withPage";
import OrderForm from "../Forms/Orders/Order";
import { getTranslation } from "../../utils/helper";
import Cookies from "js-cookie";

const defaultCountryCode = window.location.href.includes("nordicrouting.se") ? "se" : "sg";

const OrdersNewPage = ({
  action,
  isFetching,
  status,
  doCreateOrder,
  doGetAllOrders,
  groups = [],
  doGetAllGroups,
  history,
  query,
}) => {
  const user = useSelector(state => state.auth.user);
  const setting = useSelector(state => state.setting.setting) || user?.company;
  const routePlanType = query?.routePlanType || setting?.routePlanType || "PDP";
  const [countryCodeInit, setCountryCodeInit] = useState(defaultCountryCode);

  useEffect(() => {
    setCountryCodeInit(Cookies.get(`CountryCode-${user._id}`) || defaultCountryCode);
  }, []);

  useEffect(() => {
    doGetAllGroups();
  }, []);

  useEffect(() => {
    if (action === "create" && status === "succeeded") {
      doGetAllOrders();
      history.push(query.redirectUrl ? query.redirectUrl : `/orders?routePlanType=${routePlanType}`);
    }
  }, [isFetching]);

  return (
    <div className="Content OrdersNewPage">
      <div className="ContentHeader">
        <div className="HeaderTitle">
          <Link to={"/orders"}>{getTranslation(setting, "Orders", "Orders")}</Link>
          <ReactSVG className="icon" src="/icons/arrow-forward.svg" />
          <span className="Link">{getTranslation(setting, "Orders", "Add Single Order")}</span>
        </div>
      </div>
      <div className="ContentMain">
        <OrderForm
          isFetching={isFetching}
          doCreateOrder={doCreateOrder}
          groups={groups}
          query={query}
          countryCodeInit={countryCodeInit}
        />
      </div>
    </div>
  );
};

export default withPage(ItemContainer(OrdersNewPage));
